import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class CenterCurrentWindowMessage extends WebViewMessage {
  public constructor() {
    super(MessageType.CenterCurrentWindow);
  }
}
